import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isInitializing: false,
  isLoading: false,
  error: null,
  approvers: [],
};

const slice = createSlice({
  name: 'internal-user-approvers',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      if (!state.approvers || state.approvers.length === 0) {
        state.isInitializing = true;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitializing = false;
    },

    getApproversSuccess(state, action) {
      state.isLoading = false;
      state.approvers = action.payload;
      state.isInitializing = false;
    },
  },
});

export function getApprovers() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/internal/accounts/approvers');
      dispatch(slice.actions.getApproversSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export default slice.reducer;
